module.exports = __webpack_public_path__ + "img/Group 427320598.c0fa6191.png";